import { autoRegisterFeature } from '@store/features/factory';

import { serverUiFeature } from './store/feature';

autoRegisterFeature(serverUiFeature);

export { ComponentSlot } from './components';
export { ActionList } from './components/ActionList';
export type {
  DomainComponentRegistry,
  ServerUiScope,
  SkeletonComponentMap,
  SkeletonProps,
} from './components/ServerUiDomainProvider';
export {
  ServerUiDomainProvider,
  useActionTargetOverrides,
  useServerUiMutationHandler,
  useServerUiScope,
} from './components/ServerUiDomainProvider';
export { useActionDispatch } from './hooks/useActionDispatch';
export * from './store';
export * from './types';
